/** Share one refresh call across overlapping 401s so they do not rotate the cookie twice. */
function createSingleFlight (fn) {
  let inFlight = null
  return function singleFlight () {
    if (!inFlight) {
      inFlight = Promise.resolve()
        .then(() => fn())
        .finally(() => {
          inFlight = null
        })
    }
    return inFlight
  }
}

/** Replay a request once after a successful refresh. A failed refresh returns the original 401. */
async function retryOnceOnUnauthorized (send, refresh) {
  const response = await send()
  if (response.status !== 401) return response
  const refreshed = await refresh()
  if (!refreshed) return response
  return send()
}

module.exports = {
  createSingleFlight,
  retryOnceOnUnauthorized
}
